import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';
import useUserStore from '../../../store/UserStore';

interface VerificationStatus {
  isPhoneNumberVerified: boolean;
  isEmailAddressVerified: boolean;
}

interface VerificationResponse {
  status: number;
  message: string;
  data: VerificationStatus;
}

const fetchUserVerificationStatus = async (): Promise<VerificationStatus> => {
  const { data } = await axiosInstance().post<VerificationResponse>(
    'newUsers/checkUserVerificationStatus'
  );
  return data?.data || { isPhoneNumberVerified: false, isEmailAddressVerified: false };
};

export const useUserPhoneNumberVerification = () => {
  const token = useUserStore().token;

  const {
    data: verificationStatus,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['userVerificationStatus', token],
    queryFn: fetchUserVerificationStatus,
    staleTime: 60 * 1000,
  });

  return {
    isPhoneNumberVerified: verificationStatus?.isPhoneNumberVerified ?? false,
    isEmailAddressVerified: verificationStatus?.isEmailAddressVerified ?? false,
    isLoading,
    error,
    refetch,
  };
};

